module.exports = __webpack_public_path__ + "static/img/sidebar-logo.0fc71afa.svg";